import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { IDocumentaryRecord } from 'modules/video-conference/interfaces/appointment-notes.inteface';
import { Observable } from 'rxjs';

@Injectable()
export class DocumentaryRecordService {
	serviceUrl = environment.microservices.professional.url;
	constructor(private httpClient: HttpClient) {}

	public getData(appointmentId: string): Observable<IDocumentaryRecord> {
		return this.httpClient.get<IDocumentaryRecord>(
			`${this.serviceUrl}/documentary-record/${appointmentId}`
		);
	}

	public saveDocumentaryRecord(
		newNote: IDocumentaryRecord
	): Observable<IDocumentaryRecord> {
		return this.httpClient.post<IDocumentaryRecord>(
			`${this.serviceUrl}/documentary-record`,
			newNote
		);
	}
}
